import * as React from 'react';

export const useSecondsLeft = (secondsLeft: number) => {
  const [seconds, setSeconds] = React.useState(secondsLeft);

  const reset = React.useCallback(() => {
    setSeconds(secondsLeft);
  }, [secondsLeft]);

  React.useEffect(() => {
    if (seconds > 0) {
      const timer = () => {
        setSeconds(sec => sec - 1);
      };

      const interval = setInterval(timer, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [seconds > 0]);

  return { seconds, reset };
};
